import CreateLotteryModal from './CreateLotteryModal';
import PostLottery from './PostLottery';
import EditLotteryModal from './EditLotteryModal';
import ListLotteryModal from './ListLotteryModal';

export const components = {
  CreateLotteryModal: CreateLotteryModal,
  PostLottery: PostLottery,
  EditLotteryModal: EditLotteryModal,
  ListVotersModal: ListLotteryModal,
};
